var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"form-inline searchbox pull-left\">\n    <div class=\"form-group\">\n        <div class=\"input-group\" style=\"line-height: 24px;\">\n            <span class=\"input-group-addon\">\n                <i class=\"fa fa-search\"></i>\n            </span>\n            <input type=\"text\" class=\"form-control\"\n                   autocomplete=\"off\"\n                   spellcheck=\"false\" />\n        </div>\n    </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./system/ui/template/search.hbs
// module id = 1151
// module chunks = 0